import { createStructuredSelector } from 'reselect'

import {
  EQUIPMENT_LIST,
  EQUIPMENT_LIST_SUCCESS, 
  EQUIPMENT_LIST_ERROR,
  EQUIPMENT_PAGE_SET,
  EQUIPMENT_SEARCH_SET,
  EQUIPMENT_SEARCH_CHANGE,
  EQUIPMENT_ADD_SET,
  EQUIPMENT_ADD_MODAL_SET,
  EQUIPMENT_ADD,
  EQUIPMENT_ADD_SUCCESS,
  EQUIPMENT_ADD_ERROR,
  EQUIPMENT_ADD_CHANGE,
  EQUIPMENT_DETAIL,
  EQUIPMENT_DETAIL_SUCCESS,
  EQUIPMENT_DETAIL_ERROR,
  EQUIPMENT_VIEW_MODAL_SET,
  EQUIPMENT_EDIT_CHANGE,
  EQUIPMENT_EDIT_MODAL_SET,
  EQUIPMENT_UPDATE,
  EQUIPMENT_UPDATE_SUCCESS,
  EQUIPMENT_UPDATE_ERROR,
  EQUIPMENT_VIEW_TAB_SET
} from '../../actions';

export const NAME = 'equipment';

export const EquipmentList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: EQUIPMENT_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const EquipmentListSuccess = (data) => ({
  type: EQUIPMENT_LIST_SUCCESS,
  payload: data
});

export const EquipmentListError = (error) => ({
  type: EQUIPMENT_LIST_ERROR,
  payload: error
});

export const EquipmentPageSet = (data) => ({
  type: EQUIPMENT_PAGE_SET,
  payload: data
});

export const EquipmentSearchSet = (data) => ({
  type: EQUIPMENT_SEARCH_SET,
  payload: data
});

export const EquipmentSearchChangeSet = (data) => ({
  type: EQUIPMENT_SEARCH_CHANGE,
  payload: data
});

export const EquipmentAddChangeSet = (data) => ({
  type: EQUIPMENT_ADD_CHANGE,
  payload: data
});

export const EquipmentAddSet = (data) => ({
  type: EQUIPMENT_ADD_SET,
  payload: data
});

export const EquipmentAddModalSet = (data) => ({
  type: EQUIPMENT_ADD_MODAL_SET,
  payload: data
});

export const EquipmentAdd = (data) => ({
  type: EQUIPMENT_ADD,
  payload: data
});

export const EquipmentAddSuccess = (message) => ({
  type: EQUIPMENT_ADD_SUCCESS,
  payload: message
});

export const EquipmentAddError = (error) => ({
  type: EQUIPMENT_ADD_ERROR,
  payload: error
});

export const EquipmentDetail = (data) => ({
  type: EQUIPMENT_DETAIL,
  payload: data
});

export const EquipmentDetailSuccess = (data) => ({
  type: EQUIPMENT_DETAIL_SUCCESS,
  payload: data
});

export const EquipmentDetailError = (error) => ({
  type: EQUIPMENT_DETAIL_ERROR,
  payload: error
});

export const EquipmentViewModalSet = (data) => ({
  type: EQUIPMENT_VIEW_MODAL_SET,
  payload: data
});

export const EquipmentEditModalSet = (data) => ({
  type: EQUIPMENT_EDIT_MODAL_SET,
  payload: data
});

export const EquipmentEditChangeSet = (data) => ({
  type: EQUIPMENT_EDIT_CHANGE,
  payload: data
});

export const EquipmentUpdate = (data) => ({
  type: EQUIPMENT_UPDATE,
  payload: data
});

export const EquipmentUpdateSuccess = (message) => ({
  type: EQUIPMENT_UPDATE_SUCCESS,
  payload: message.message
});

export const EquipmentUpdateError = (error) => ({
  type: EQUIPMENT_UPDATE_ERROR,
  payload: error
});

export const EquipmentViewTabSet = (data) => ({
  type: EQUIPMENT_VIEW_TAB_SET,
  payload: data
});


const equipment = (state) => state[NAME];

export const EquipmentSelector = createStructuredSelector({
  equipment
})
 